const classNames = require('classnames')
const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const Element = require('../model/element.base')
const InputAttributes = require('./input_attributes')

const template = `
    <span class="default-text">{{ data.label }}</span>
    <span class="loading-text">{{ data.loading_label }}</span>
`

const InputButtonView = Marionette.View.extend({

    displayName: 'InputButtonView',

    tagName: 'button',

    template: _.template(template),

    className() {
        const attrs = this.model.serialize()
        const className = classNames([
            attrs.className,
        ], {
            disabled: attrs.disabled || attrs.loading,
            loading: attrs.loading,
        })
        return className
    },

    setClassName() {
        const className = _.result(this, 'className')
        this.$el.attr('class', className)
    },

    attribute_keys: ['type', 'id', 'name', 'disabled'],

    ui: {
        label: '.default-text',
        loading_label: '.loading-text',
    },

     
    constructor: function constructor() {
        Marionette.View.apply(this, arguments)

        // validate model
        if (! (this.model instanceof Element)) throw new Error('InputView requires an Element model.')

        // these steps allow the view to consume an existing dom element
        this.listenTo(this, 'render', this.setAttributes)
        this.listenTo(this, 'render', this.setClassName)

        this.listenTo(this.model, 'change:label', this.onChangeLabel)
        this.listenTo(this.model, 'change:loading_label', this.onChangeLoadingLabel)
        this.listenTo(this.model, 'change:loading', this.onChangeLoading)
        this.listenTo(this.model, 'change:disabled', this.onChangeDisabled)
        this.listenTo(this.model, 'change:className', this.setClassName)
    },

    triggers() {
        const triggers = {}
        const trigger = this.model.get('trigger')

        if (trigger) {
            triggers.click = {
                event: trigger,
                preventDefault: false,
                stopPropagation: false,
            }
        }

        return triggers
    },

    onChangeLabel(model, label) {
        this.ui.label.text(label)
    },

    onChangeLoadingLabel(model, label) {
        this.ui.loading_label.text(label)
    },

    onChangeLoading(model, loading) {
        this.setAttributes()
        this.setClassName()
    },
    onChangeDisabled(model, disabled) {
        this.setAttributes()
        this.setClassName()
    },

})

// apply methods from InputAttributes mixin
_.extend(InputButtonView.prototype, InputAttributes)

module.exports = InputButtonView
